export enum RevisorFilterType {
  ALL_ENTRIES = 'ALL_ENTRIES',
  ENTRIES_TO_BE_CHECKED = 'ENTRIES_TO_BE_CHECKED',
  CHECKED_ENTRIES = 'CHECKED_ENTRIES',
}
